import React from "react";
import moment from "moment";
class BarComponent extends React.Component {
  render() {
    const { activiteit } = this.props;
    function datum(cell) {
      return moment(cell).format("DD-MM-YYYY HH:mm");
    }

    function teldeelnemers(inschrijvingen) {
      if (inschrijvingen.length > 0) {
        var u = inschrijvingen.map((item) => item.personen).reduce((prev, next) => prev + next);
        return u;
      } else {
        return 0;
      }
    }
    return (
      <div className="barback">
        <div className="row">
          <div className="col-md-3 col-sm-6 col-xs-12">
            <div className="info-box">
              <span className="info-box-icon bg-aqua">
                <i className="fa fa-clock-o"></i>
              </span>

              <div className="info-box-content">
                <span className="info-box-text">Start Inschrijving</span>
                <span className="info-box-number">{datum(activiteit.startinschrijving)}</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12">
            <div className="info-box">
              <span className="info-box-icon bg-aqua">
                <i className="fa fa-clock-o"></i>
              </span>

              <div className="info-box-content">
                <span className="info-box-text">Einde Inschrijving</span>
                <span className="info-box-number">{datum(activiteit.eindinschrijving)}</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12">
            <div className="info-box">
              <span className="info-box-icon bg-aqua">
                <i className="fa fa-users"></i>
              </span>

              <div className="info-box-content">
                <span className="info-box-text">Maximaal deelnemers</span>
                <span className="info-box-number">{activiteit.maxdeelnemers}</span>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 col-xs-12">
            <div className="info-box">
              <span className="info-box-icon bg-aqua">
                <i className="fa fa-users"></i>
              </span>
              <div className="info-box-content">
                <span className="info-box-text">Aantal deelnemers</span>
                <span className="info-box-number">{teldeelnemers(activiteit.inschrijvingen)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default BarComponent;
